<template>
  <v-container fluid>
    <v-row  dense>
      <v-col cols="12">
        <!-- <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/> -->
        <DataTableMainServer :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"
        :Updatepagination="params" :on-pagination="pagePagination" :on-search="getSearchPagePagination"/>
        <ViewDetails :object="object" type="DetailEquipo" />
        <ReportPDFDialog :dialog2="openDialog"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
// import DataTableMain from '@/components/tables/DataTableMain'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'
import ReportPDFDialog from '@/components/dialog/ReportPDFDialog'
import XLSX from 'xlsx'

export default {
  mixins: [Permission],
  data: () => ({
    openDialog: false,
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'bien.inventariable.entry' },
          {
            title: 'Opciones',
            icon: 'mdi-cloud-download',
            color: 'light-blue lighten-1',
            code: 'libre',
            hidden: '',
            options: [
              { title: 'Reporte General PDF', icon: 'mdi-file-pdf-box', color: 'blue-grey lighten-1', action: 'showDialogFechas', pagination: {}, code: 'libre', hidden: '' },
              { title: 'Etiquetas', icon: 'mdi-file-excel', color: 'blue-grey lighten-1', action: 'showEtiquetas', pagination: {}, code: 'libre', hidden: '' },
              { title: 'Reporte General XLSX', icon: 'mdi-file-excel', color: 'blue-grey lighten-1', action: 'showGralInventarios', pagination: {}, code: 'inventario.asignados.show-rpt-gral-xlsx' }
            ]
          }

        ],
        titles: [
          { text: 'no. Inventario', value: 'folio', class: 'black--text' },
          { text: 'Familia', value: 'familia.nombre', class: 'black--text' },
          { text: 'Departamento', value: 'departamento.nombre', class: 'black--text' },
          { text: 'Procedencia', value: 'caracteristicas.procedencia.nombre', class: 'black--text' },
          { text: 'Marca', value: 'MarcaModelo', class: 'black--text' },
          { text: 'Proveedor', value: 'caracteristicas.proveedor.nombre', class: 'black--text' },
          { text: 'Tipo', value: 'familia.padre.nombre', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text', align: 'center' },
          { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: true
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'toUpdate', code: 'bien.inventariable.entry' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {}
  }),
  components: {
    DataTableMainServer,
    // DataTableMain,
    ViewDetails,
    ReportPDFDialog
  },
  mounted () {
    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjectService', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES', 'SHOW_DIALOG_REPORT']),
    SuccessTableAction (item) { this[item.action](item) },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    // *==========*==========*==========*    Methods Table Pagination    *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true
      if (val) this.params = val
      else this.params = this.default
      this.ExecuteUrl('inventariables.list-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('inventariables.list-pagination')
      // this.pages = val
    },
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    showDialogFechas (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'tickets',
        with: '60%',
        title: 'Reporte General',
        body: {
          objectMain: this.filterTableData,
          paramsDialog: {
            form: this.get_ReporteGeneralInventariablesForm,
            message: 'Registro Agregado Correctamente',
            paramsForm: { hiddenBtnSuccess: true, nameBtnSuccess: 'Descargar PDF' }
          }
        }
      })
    },
    showEtiquetas (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'tickets',
        with: '60%',
        title: 'Descargar Tickets de Inventarios',
        body: {
          objectMain: this.filterTableData,
          paramsDialog: {
            form: this.get_TicketsDepartamentoForm,
            message: 'Registro Agregado Correctamente',
            paramsForm: { hiddenBtnSuccess: true, nameBtnSuccess: 'Descargar PDF' }
          }
        }
      })
    },
    showGralInventarios (item) {
      const router = this.get_urls['inventario.asignados.show-rpt-gral-xlsx']
      this.GETObjectService({ url: router })
    },

    filterData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'filter',
        with: '60%',
        title: 'FILTRAR',
        body: {
          objectMain: this.filterTableData,
          paramsDialog: {
            form: this.get_InventariosEquiposFilterForm,
            message: 'Registro Agregado Correctamente',
            returnObject: true,
            setmodel: true
          }
        }
      })
    },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('inventariables.list-pagination')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Nuevo Bien Inventariable',
        body: {
          objectMain: { tipo_inventario_id: 6, departamento_id: UserSession().departamento_id },
          paramsDialog: {
            urloption: this.get_urls['inventario.options'],
            url: this.get_urls['inventario.execute'],
            process: 1, // comienzo del proceso del status detonante
            actividad: 6, // tipo de actividad
            message: 'Registro Agregado Correctamente',
            showFamilia: true,
            familiaParams: '?insumo=2,0',
            setmodel: true
          }
        }
      })
    },
    toUpdate (item) {
      const estatusIds = [42, 43, 57, 67, 48, 63]
      // Verificar si el estatus_id está en el array
      if (estatusIds.includes(item.item.last_movement.estatus_id)) {
        this.$swal.fire({
          type: 'error',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'El bien ya no se puede editar debido a su estatus actual.'
        })
        return
      }
      const data = {
        id: item.item.id,
        descripcion: item.item.caracteristicas.descripcion,
        proveedor: item.item.caracteristicas.proveedor,
        proveedor_id: item.item.caracteristicas.proveedor_id,
        marca_id: item.item.caracteristicas.marca_id,
        Alta: item.item.caracteristicas.Alta,
        Compra: item.item.caracteristicas.Compra,
        comentarios: item.item.caracteristicas.comentarios,
        procedencia_id: item.item.caracteristicas.procedencia_id,
        tipo_solicitud: item.item.caracteristicas.tipo_solicitud,
        PrecioU: item.item.caracteristicas.PrecioU,
        facturas: item.item.factura,
        factura_id: item.item.caracteristicas.factura_id,
        partida_ids: item.item.caracteristicas.partida_ids || [],
        departamento_id: item.item.departamento_id,
        departamento: item.item.departamento
      }
      // console.log(data)
      // Mostrar el diálogo de actualización
      this.SHOW_DIALOG_MAIN({
        type: 'update',
        form: 'process',
        with: '60%',
        title: 'Editar Bien',
        body: {
          objectMain: data,
          paramsDialog: {
            urloption: this.get_urls['inventario.options'],
            url: this.get_urls['inventario.execute'],
            process: 1,
            actividad: item.item.tipo_inventario_id, // 6
            message: 'Registro Actualizado Correctamente',
            showFamilia: true,
            familiaParams: '?insumo=2,0',
            familiaSelected: item.item.caracteristicas.familia_id,
            setmodel: true,
            updated: true,
            data: (item.item.especificaciones) ? item.item.especificaciones : {}
          }
        }
      })
    },
    toAssign (item) {
      console.log('item', item)
      const Copyitem = JSON.parse(JSON.stringify(item))
      const fields = Copyitem.body.status_finish.formulario.fields
      fields.map(field => {
        if (field.nameid === 'empleado_id') { field.url += `/${item.item.departamento_id}` }
      })
      this.SHOW_DIALOG_MAIN({
        type: 'assign',
        form: 'process',
        with: '55%',
        title: 'Documento de Asignación',
        body: {
          objectMain: Copyitem,
          paramsDialog: {
            url: this.get_urls['inventario.execute'],
            urloption: this.get_urls['inventario.options'],
            message: 'Bien Asignado',
            setmodel: true,
            data: item.item
          },
          method: 'form-data'
        }
      })
    },
    toStock (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'stock',
        form: 'process',
        with: 500,
        title: 'Enviar Bien a Stock',
        body: {
          objectMain: item,
          paramsDialog: {
            urloption: this.get_urls['inventario.options'],
            url: this.get_urls['inventario.execute'],
            process: 1,
            message: 'Registro Almacenado Correctamente'
          }
        }
      })
    },
    toBaja (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'baja',
        form: 'process',
        with: 500,
        title: 'Solicitud De Baja',
        body: {
          objectMain: item,
          paramsDialog: {
            urloption: this.get_urls['inventario.options'],
            url: this.get_urls['inventario.execute'],
            process: 1,
            message: 'Baja En Proceso'
          }
        }
      })
    },
    toCancel (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'cancel',
        form: 'process',
        with: 500,
        title: 'Cancelar',
        body: {
          objectMain: item,
          paramsDialog: {
            urloption: this.get_urls['inventario.options'],
            url: this.get_urls['inventario.execute'],
            process: 1,
            message: 'cancelado'
          }
        }
      })
    },
    toTransfe (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'transferencia',
        form: 'process',
        with: 500,
        title: 'Solicitud De Transferencia',
        body: {
          objectMain: item,
          paramsDialog: {
            urloption: this.get_urls['inventario.options'],
            url: this.get_urls['inventario.execute'],
            process: 1,
            message: 'Transferecia En Proceso'
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objectPagination', 'get_object',
      'get_InventariosEquiposFilterForm', 'get_TicketsDepartamentoForm', 'get_ReporteGeneralInventariablesForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
    },
    get_object (response) {
      console.log(response)
      const data = XLSX.utils.json_to_sheet(response.data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data, 'data')
      XLSX.writeFile(wb, `${response.nombre}.xlsx`)
    },
    get_sendDataView ({ name, model }) {
      if (name === 'create') {
        this.refreshData({})
      }
      this.SEND_DATA_VIEW({})
    }
  }
}
</script>

<style>
</style>
